// src/components/ErrorBoundary.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can log error here
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Navigate to error page
      return <Navigate to="/error" replace />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;